// store/college/course-management/store/saga.js
import { call, put, takeLatest, all, fork } from 'redux-saga/effects';
import * as types from './_actionTypes';
import * as actions from './_actions';

import CollegeCourseHelper from '../../../../utils/API/BackendHelper/college/coursesinfo';
// API Calls


// Worker Sagas
function* fetchPurchasedCoursesSaga(action) {
  try {
    const response = yield call(CollegeCourseHelper.getPurchasedCourses);
    
    if (response.success) {
      yield put(actions.fetchPurchasedCoursesSuccess(response.data));
    } else {
      yield put(actions.fetchPurchasedCoursesFailure(response.message));
    }
  } catch (error) {
    yield put(
      actions.fetchPurchasedCoursesFailure(
        error.response?.message || 'Failed to fetch purchased courses'
      )
    );
  }
}

function* fetchAllCoursesSaga(action) {
  try {
   
    const response = yield call(CollegeCourseHelper.getAllCourses);
    
    if (response.success) {
      yield put(actions.fetchAllCoursesSuccess(response.data));
    } else {
      yield put(actions.fetchAllCoursesFailure(response.message));
    }
  } catch (error) {
    yield put(
      actions.fetchAllCoursesFailure(
        error.response?.message || 'Failed to fetch all courses'
      )
    );
  }
}

// function* purchaseCourseSaga(action) {
//   try {
//     const { courseId, collegeId } = action.payload;
//     const response = yield call(purchaseCourseAPI, courseId, collegeId);
    
//     if (response.data.success) {
//       yield put(actions.purchaseCourseSuccess(response.data.data));
//       // Optionally refetch purchased courses
//       yield put(actions.fetchPurchasedCoursesRequest(collegeId));
//     } else {
//       yield put(actions.purchaseCourseFailure(response.data.message));
//     }
//   } catch (error) {
//     yield put(
//       actions.purchaseCourseFailure(
//         error.response?.data?.message || 'Failed to purchase course'
//       )
//     );
//   }
// }

// Fetch both APIs in parallel on initial load
function* fetchAllCoursesDataSaga(action) {
  try {
    const { collegeId } = action.payload;
    
    // Run both API calls in parallel
    yield all([
      fork(fetchPurchasedCoursesSaga, { payload: { collegeId } }),
      fork(fetchAllCoursesSaga, { payload: { collegeId } })
    ]);
  } catch (error) {
    console.error('Error fetching courses data:', error);
  }
}

function* fetchStudentEnrollmentStatsSaga(action) {
  try {
    const filters = action.payload || {};
    

    
    const response = yield call(
      CollegeCourseHelper.getStudentEnrollmentStats, filters
    );
    
    yield put(actions.fetchStudentEnrollmentStatsSuccess(response.data));
  } catch (error) {
    yield put(actions.fetchStudentEnrollmentStatsFailure(
      error.response?.data?.message || 'Failed to fetch enrollment statistics'
    ));
  }
}

// function* fetchCourseEnrollmentDetailsSaga(action) {
//   try {
//     const courseId = action.payload;
    
//     const response = yield call(
//       apiClient.get,
//       `/college/courses/${courseId}/enrollment-details`
//     );
    
//     yield put(actions.fetchCourseEnrollmentDetailsSuccess(response.data));
//   } catch (error) {
//     yield put(actions.fetchCourseEnrollmentDetailsFailure(
//       error.response?.data?.message || 'Failed to fetch enrollment details'
//     ));
//   }
// }

// Watcher Sagas
function* watchFetchPurchasedCourses() {
  yield takeLatest(types.FETCH_PURCHASED_COURSES_REQUEST, fetchPurchasedCoursesSaga);
}

function* watchFetchAllCourses() {
  yield takeLatest(types.FETCH_ALL_COURSES_REQUEST, fetchAllCoursesSaga);
}

function* watchFetchStudentEnrollmentStats() {
  yield takeLatest(types.FETCH_STUDENT_ENROLLMENT_STATS_REQUEST, fetchStudentEnrollmentStatsSaga);
}

// function* watchFetchStudentEnrollmentStats() {
//   yield takeLatest(types.FETCH_STUDENT_ENROLLMENT_STATS_REQUEST, fetchStudentEnrollmentStatsSaga);
// }

// function* watchFetchCourseEnrollmentDetails() {
//   yield takeLatest(types.FETCH_COURSE_ENROLLMENT_DETAILS_REQUEST, fetchCourseEnrollmentDetailsSaga);
// }

// function* watchPurchaseCourse() {
//   yield takeLatest(types.PURCHASE_COURSE_REQUEST, purchaseCourseSaga);
// }

// Root Saga
export default function* courseSaga() {
  yield all([
    fork(watchFetchPurchasedCourses),
    fork(watchFetchAllCourses),
    
     fork(watchFetchStudentEnrollmentStats),
    // fork(watchFetchCourseEnrollmentDetails),
  //  fork(watchPurchaseCourse)
  ]);
}
